<template>
  <vx-card>
    <div class="new-post flex px2 justify-content-between">
      <div>
        <vs-avatar class="m-0" :src="this.$store.getters['auth/user'].image" icon-pack="feather" size="45px" @click="viewProfile(user.id)"></vs-avatar>
      </div>
      <div class="w-full">
        <div class="PostForm">
          <div class="ml-5">
            <textarea-autosize :disabled="posting" class="w-full" :dir="postText ? 'auto' : 'rtl'" :placeholder="postPlaceholder" rows="3" v-model="postText"/>
          </div>
          <div class="post-action w-full pl-5">
            <div v-if="type === 'poll'" class="poll">
              <vs-button class="removeBtn" :disabled="posting" @click="removePoll" radius color="dark" type="flat" icon-pack="feather" icon="icon-x"></vs-button>
              <div v-for="(choice, index) in polls" :key="index" class="choice flex">
                <vs-input v-model="choice.title" :label="(index+1) | numberToString" :disabled="posting"/>
                <vs-button v-if="(polls.length - 1 === index && polls.length < 4)" :disabled="posting"
                           @click="polls.push({title: '', votes_num: 0})"
                           class="mt-8 mx-2" type="flat" radius icon-pack="feather" icon="icon-plus"></vs-button>
              </div>
            </div>

            <div class="con-img-upload vx-row">
              <div v-for="(img,index) in srcs"
                   :class="{'fileError':img.error, 'removeItem':itemRemove.includes(index), }"
                   :key="index" class="vx-col w-full">

                <div class="img-upload" @click.self="$emit('viewImage',img.src)"
                     :style="{backgroundImage: `url(${img.src})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover'}">
                  <button class="btn-x-file" type="button" @click="removeImage(index)" :disabled="posting">
                    <vs-icon icon="icon-x" icon-pack="feather" />
                  </button>
                </div>
              </div>
            </div>

            <file v-if="type === 'file' || type === 'video'" class="mb-5" upload
                  :name="file.name" :size="file.size" @remove="removeFile" :disabled="posting"/>

            <vs-progress v-if="posting" :percent="progress" color="primary"></vs-progress>
            <vs-divider class="mt-0"/>
          </div>

          <div class="flex flex-wrap">
            <div class="flex">
              <vs-button :disabled="disableImagesBtn" @click="uploadImageBtn" class="large" radius color="primary" type="flat" icon-pack="feather" icon="icon-image"></vs-button>
              <vs-button :disabled="disableImagesBtn" @click="uploadImageBtn" class="large" radius color="primary" type="flat" icon-pack="feather" icon="icon-video"></vs-button>
              <vs-button :disabled="type !== 'normal'" @click="uploadFileBtn" class="large mr-2" radius color="primary" type="flat" icon-pack="feather" icon="icon-paperclip"></vs-button>
              <vs-button :disabled="type !== 'normal'" @click="pollBtn" class="large mr-2" radius color="primary" type="flat" icon-pack="feather" icon="icon-list"></vs-button>
              <input ref="imageInput" accept="image/*, video/*" type="file" @change="getImages" hidden>
              <input ref="fileInput" accept=".pdf, .docx, .doc, .txt, .zip, .rar" type="file" @change="getFiles" hidden>
            </div>
            <vs-button @click="addPost" class="ml-auto" icon-pack="feather" icon="icon-send" icon-after>
              <span v-if="$store.state.windowWidth >= 992">نشر</span>
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
    import postsAPI from "@/api/postsAPI";

    export default {
        name: 'PostForm',
        props: {
            privacy: {
                type: String,
                default: 'public'
            },
        },
        inheritAttrs:false,
        data() {
            return {
                postText: '',
                type: 'normal',
                srcs: [],
                images: [],
                imagesLimit: 1,
                file: null,
                polls: [],
                itemRemove: [],
                posting: false,
                progress: 0,
            }
        },
        computed: {
            postPlaceholder(){
              if(this.type === 'poll'){
                  return 'اكتب سؤالك ؟'
              }  else {
                  return 'قم بكتابة منشور جديد...'
              }
            },
            disableImagesBtn(){
                return (this.type !== 'normal' && this.type !== 'image') || (this.type === 'image' && this.imagesLength >= this.imagesLimit)
            },
            imagesLength(){
                return this.srcs.length - this.itemRemove.length
            }
        },
        filters: {
            numberToString(number){
                if(number === 1){
                    return 'الخيار الأول'
                } else if(number === 2){
                    return 'الخيار الثاني'
                } else if(number === 3){
                    return 'الخيار الثالث'
                } else if (number === 4){
                    return 'الخيار الرابع'
                } else {
                    return 'الخيار ' + number
                }
            },
        },
        methods:{
            pollBtn(){
                if(this.type === 'normal') {
                    this.type = 'poll';
                    this.polls = [{title: '', votes_num: 0},{title: '', votes_num: 0}]
                }
            },
            removePoll(){
                this.type = 'normal'
                this.polls = []
            },

            uploadFileBtn(){
                if(this.type === 'normal')
                    this.$refs.fileInput.click()
            },
            removeFile(){
                this.file = null;
                this.type = 'normal'
            },
            getFiles(e) {
                this.file = e.target.files[0];
                const input = this.$refs.fileInput;
                input.type = 'text';
                input.type = 'file';
                this.type = 'file'
            },

            uploadImageBtn(){
                if(!this.disableImagesBtn)
                    this.$refs.imageInput.click()
            },
            removeImage(index){
                this.itemRemove.push(index);
                // setTimeout(()=>{
                //     this.images[index].remove = true
                // },301);

                if(this.imagesLength < 1)
                    this.type = 'normal'
            },
            getImages(e){
                const files = e.target.files;
                if(files[0].type.split('/')[0] === 'video') {
                    this.file = e.target.files[0];
                    const input = this.$refs.fileInput;
                    input.type = 'text';
                    input.type = 'file';
                    this.type = 'video'

                    return
                }
                let _this = this;
                let count = (this.srcs.length - this.itemRemove.length);
                for (const file in files) {
                    if (files.hasOwnProperty(file)) {
                        if(this.imagesLimit) {
                            count ++;
                            if( count > Number(this.imagesLimit) ) {
                                break
                            }
                        }
                        var reader  = new FileReader();
                        const filex = files[file];
                        if (/image.*/.test(filex.type)) {
                            this.images = (filex);
                            reader.onload = function(e){
                                var image = new Image();
                                image.src = e.target.result;
                                image.onload = function() {
                                    _this.srcs.push({
                                        src:image.src,
                                        type:'image',
                                        error:false,
                                        remove:null
                                    })
                                }
                            };
                            reader.readAsDataURL(filex);
                        }
                    }
                }
                const input = this.$refs.imageInput;
                input.type = 'text';
                input.type = 'file';
                this.type = 'image'
            },

            addPost(){
                // console.log()
                let polls = this.polls.filter(item => {
                    return item.title.trim() !== ''
                })
                if(this.type === 'poll' && polls.length < 2) {
                    polls = []
                    this.type = null
                }

                if(this.postText.trim() === '' && this.type === 'normal')
                    return false

                let post = {
                    text: this.postText,
                    type: this.type,
                    images: this.images,
                    polls: JSON.stringify(polls),
                    file: this.file,
                    privacy: this.privacy
                };

                let postData = new FormData()
                for(let key in post){
                    postData.append(key, post[key])
                }

                let config = {
                    onUploadProgress: (progressEvent) =>
                        {this.progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total )}
                }

                this.posting = true
                postsAPI.create(postData, config).then( response => {
                      let data = response.data
                      post.id = data.id
                      post.comments = []
                      post.user = this.user
                      post.polls = []

                      if(post.type === 'poll'){
                          data.polls.forEach(choice => {
                              post.polls.push({
                                  id: choice.id,
                                  title: choice.title,
                                  is_checked: false,
                                  votes_num: 0
                              })
                          })
                      } else if (post.type === 'file'){
                          post.files = data.files
                      } else if (post.type === 'image'){
                          post.images = data.files
                      } else if (post.type === 'video'){
                          post.videos = data.files
                      }

                      this.$emit('submit', post);
                      this.clearForm()
                      this.$notifySuccess(response.successMessage)
                    })
                    .catch((error) => {
                        this.$notifyError(error.statusMessage)
                    })
                    .finally(() => {
                        this.posting = false
                        this.progress = 0
                    })
            },

            clearForm() {
                this.type = 'normal'
                this.srcs = []
                this.images = []
                this.file = null
                this.polls = []
                this.itemRemove = []
                this.postText= ''
            }
        },
    }
</script>
<style lang="scss" scoped>
    .con-img-upload {
        .removeItem {
            -webkit-transition: all .3s ease,height .2s ease .2s;
            transition: all .3s ease,height .2s ease .2s;
            opacity: 0!important;
            width: 0!important;
            visibility: hidden;
            margin: 0!important;
            padding: 0!important;
            height: 0!important;
        }
        .img-upload {
            width: 100%;

            .btn-x-file {
                opacity: 1;
                -webkit-transform: translate(0);
                transform: translate(0);
            }
        }
    }
    .file-content {
      border-radius: .5rem;
      position: relative;
      .feather-icon {
        border-left: 1px solid #dae1e7;
        padding: 0 20px;
        margin: 10px 0
      }
    }
    .poll {
        position: relative;
        border: 1px solid #E5E5E5;
        padding: 10px;
        margin-top: 1rem;
        border-radius: 7px;

        .choice {
            margin: 10px 20px;
            width: 100%;
            .vs-input {
                width: 70%;
            }
        }

        .removeBtn {
            position: absolute;
            top: 10px;
            right: 10px;
        }
    }
</style>
